export default "__VITE_ASSET__3aca720a__"